<template>
    <div>
        <el-table :data="serviceChargeList">
            <el-table-column prop="coinType" label="币种"></el-table-column>
            <el-table-column label="提现Gas Price">
                <template slot-scope="scope">
                    <a @click="handleGasPriceChange(scope.row.coinType)"
                       v-if="scope.row.supportSettingWithdrawGasPriceInGwei">
                        {{scope.row.withdrawGasPriceInGwei}}<i class="el-icon-edit"></i>
                    </a>
                </template>
            </el-table-column>
            <el-table-column label="转冷Gas Price">
                <template slot-scope="scope">
                    <a @click="handleToColdGasPriceChange(scope.row.coinType)"
                       v-if="scope.row.supportSettingToColdGasPriceInGwei">
                        {{scope.row.toColdGasPriceInGwei}}<i class="el-icon-edit"></i>
                    </a>
                </template>
            </el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button type="primary" icon="el-icon-refresh" circle
                               @click="refreshRow(scope.row.coinType,scope.$index)"></el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    import {mapState, mapActions} from 'vuex';

    export default {
        name: 'ServiceChargeSetting',
        computed: {
            ...mapState('walletSwitchSetting', ['serviceChargeList', 'coinList'])
        },
        methods: {
            ...mapActions('walletSwitchSetting', [
                'getServiceChargeList',
                'editGasPrice',
                'editToColdGasPrice',
                'getSwitchInfoByCoinType'
            ]),

            handleGasPriceChange(coinType) {
                this.$prompt('请输入gas price', '提示').then(({value}) => {
                    this.editGasPrice({
                        coinType,
                        price:
                            typeof value === 'undefined' || typeof value === 'object'
                                ? undefined
                                : Number(value)
                    }).then(() => {
                        this.$message.success('操作成功！');
                        this.getServiceChargeList({coins: this.coinList.join(",")});
                    });
                });
            },
            handleToColdGasPriceChange(coinType) {
                this.$prompt('请输入gas price', '提示').then(({value}) => {
                    this.editToColdGasPrice({
                        coinType,
                        price:
                            typeof value === 'undefined' || typeof value === 'object'
                                ? undefined
                                : Number(value)
                    }).then(() => {
                        this.$message.success('操作成功！');
                        this.getServiceChargeList({coins: this.coinList.join(",")});
                    });
                });
            },

            /** 刷新单行数据*/
            refreshRow(coinType, index) {
                this.getSwitchInfoByCoinType(coinType).then(response => {
                    this.$set(this.serviceChargeList, index, response.data)
                })
            }
        },
        created() {
            this.getServiceChargeList({coins: this.coinList.join(",")});
        }
    };
</script>

<style lang="less" scoped>
</style>
